export default __webpack_public_path__ + "static/media/favicon.6ba850f5.svg";